import mapboxgl from 'mapbox-gl';

// eslint-disable-next-line import/no-mutable-exports
let MapboxGL = null;

if (mapboxgl.supported()) {
    // eslint-disable-next-line global-require
    MapboxGL = mapboxgl;
    MapboxGL.accessToken = MA.Config.MAPBOX_ACCESS_TOKEN;
}

export default MapboxGL;
